const BASE_URL = 'ai-service/api/vqa-models'

const vqaModelsRequests = {
  getVqaModelsRequest: () => ({
    url: BASE_URL,
    method: 'get',
  }),
  getVqaModelsForFormRequest: () => ({
    url: `${BASE_URL}/form`,
    method: 'get',
  }),
  getVqaModelsByFormRequest: ({ formId }) => ({
    url: `${BASE_URL}/form/${formId}`,
    method: 'get',
  }),
  addVqaModelRequest: (data) => ({
    url: BASE_URL,
    method: 'post',
    data,
  }),
  updateVqaModelRequest: (data) => ({
    url: BASE_URL,
    method: 'put',
    data,
  }),
  deleteVqaModelRequest: ({ vqaModelId }) => ({
    url: `${BASE_URL}/${vqaModelId}`,
    method: 'delete',
  }),
  publishVqaModelRequest: ({ vqaModelId, tenants }) => ({
    url: `${BASE_URL}/${vqaModelId}/publish`,
    method: 'post',
    data: {
      TenantIds: tenants.map((tenant) => tenant.Id),
    },
  }),
  unpublishVqaModelRequest: ({ vqaModelId, tenants }) => ({
    url: `${BASE_URL}/${vqaModelId}/unpublish`,
    method: 'post',
    data: {
      TenantIds: tenants.map((tenant) => tenant.Id),
    },
  }),
}

export default vqaModelsRequests
